export default __webpack_public_path__ + "static/media/mandrill-shield.25afec3b.svg";